import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {UnsavedChangesComponent} from './unsaved-changes/unsaved-changes/unsaved-changes.component';

@NgModule({
  declarations: [
    UnsavedChangesComponent
  ],
  imports: [
    CommonModule
  ],
  exports: [
    UnsavedChangesComponent
  ]
})
export class ComponentsModule {
}
